module.exports = __webpack_public_path__ + "img/sm.d9667c6e.svg";